import { Library } from '@fortawesome/fontawesome-svg-core'
import {
	faGear,
	faPenLine,
	faTriangleExclamation,
	faUser,
	faList,
	faMap,
} from '@fortawesome/pro-regular-svg-icons'

// import icons able to be used by name
// (in files loading the LibraryIconProp type)
export const loadFontAwesomeLibrary = (library: Library) => {
	library.add(
		faGear,
		faPenLine,
		faTriangleExclamation,
		faUser,
		faList,
		faMap,
	)
}
